import { faq } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">关于皮皮喵漫画，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faq.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/50">
              <h3 className="text-base font-bold text-foreground-900 mb-3 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line"></i>
                  </span>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}